export const news = [
  {
    id: "yangmi-new-drama-wrap",
    title: "杨幂新剧杀青 现场路透曝光引期待",
    category: "作品动态",
    date: "2026-09-28",
    author: "明星资讯平台",
    summary: "杨幂主演的最新剧集正式杀青，剧组发布杀青照与幕后花絮，粉丝纷纷留言期待播出。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20backstage%20celebration%20scene%20with%20film%20crew%20and%20flower%20bouquets%2C%20wrapped%20filming%20clapperboard%2C%20soft%20rose%20and%20gold%20lighting%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-wrap-01&orientation=landscape",
    content: [
      "由杨幂领衔主演的最新剧集日前正式杀青，剧组在官方社交平台发布了杀青照。照片中，杨幂身着戏服、手捧鲜花，向镜头比出感谢手势，现场气氛温馨热烈。",
      "据剧组透露，该剧拍摄历时数月，杨幂在剧中挑战了全新的角色类型，从人物设定到造型均有较大突破。拍摄期间，她多次与导演探讨角色细节，力求呈现更真实细腻的表演。",
      "杀青后，杨幂在社交平台发文感谢剧组全体成员，并写道「期待和大家在屏幕前见面」。消息发布后迅速登上热搜，众多粉丝留言表达期待，相关话题阅读量持续走高。",
      "目前该剧已进入后期制作阶段，具体定档时间尚未公布，本平台将持续跟进最新进展。",
    ],
  },
  {
    id: "yangmi-fashion-week",
    title: "杨幂亮相国际时装周 造型登上热搜",
    category: "活动",
    date: "2026-09-20",
    author: "时尚现场",
    summary: "杨幂现身国际时装周看秀，一袭玫红色高定礼服惊艳全场，造型话题迅速登上热搜榜。",
    cover: "https://readdy.ai/api/search-image?query=Glamorous%20fashion%20week%20front%20row%20scene%2C%20elegant%20woman%20in%20rose%20haute%20couture%20gown%20under%20warm%20spotlights%2C%20chic%20modern%20venue%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-fashion-02&orientation=landscape",
    content: [
      "当地时间近日，杨幂受邀出席国际时装周品牌大秀。她以一身玫红色高定礼服亮相，搭配简约配饰，整体造型高级又不失张力，成为现场媒体镜头的焦点。",
      "秀场结束后，杨幂的造型照片迅速在网络上传播，「杨幂玫红礼服」相关话题登上热搜榜前列，不少网友评价其气场十足、状态在线。",
      "作为多次登上国际时装周的中国面孔，杨幂凭借稳定的时尚表现力持续获得品牌青睐。此次亮相也被视为她在时尚领域的又一次高光时刻。",
    ],
  },
  {
    id: "yangmi-interview-career",
    title: "杨幂谈表演：保持热爱 不怕挑战新题材",
    category: "访谈",
    date: "2026-09-12",
    author: "人物专访",
    summary: "在最新一期专访中，杨幂分享了自己对表演的理解，坦言愿意不断尝试新的角色与题材。",
    cover: "https://readdy.ai/api/search-image?query=Soft%20editorial%20interview%20portrait%20setting%2C%20warm%20minimal%20studio%20with%20beige%20sofa%20and%20rose%20accent%2C%20natural%20window%20light%2C%20magazine%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-interview-03&orientation=landscape",
    content: [
      "在最新一期人物专访中，杨幂回顾了自己多年来的表演经历。她表示，随着年龄与经验的增长，自己对角色有了更深的理解，「不再只关注一个人物的外表，而是去想她为什么这么选择」。",
      "谈及挑选剧本的标准，杨幂坦言会优先考虑角色是否有挑战性和新鲜感。「我会愿意去试一些以前没演过的类型，哪怕有难度。」她说，保持热爱是支撑自己不断向前的动力。",
      "对于外界的评价，杨幂表示会理性看待，「好的建议我会吸收，但也希望自己能更专注于作品本身。」",
    ],
  },
  {
    id: "yangmi-fan-meeting",
    title: "杨幂空降见面会 与粉丝暖心互动",
    category: "活动",
    date: "2026-08-30",
    author: "现场报道",
    summary: "杨幂惊喜现身粉丝见面会，与现场粉丝游戏互动、合影留念，多次向粉丝表达感谢。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20fan%20meeting%20stage%20with%20rose%20and%20gold%20decor%2C%20happy%20crowd%20with%20light%20sticks%2C%20festive%20warm%20lighting%2C%20event%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-fans-04&orientation=landscape",
    content: [
      "日前，杨幂惊喜亮相一场粉丝见面会，现场座无虚席。她一登台便引来阵阵欢呼，气氛热烈。",
      "活动设置了多个互动环节，杨幂不仅与幸运粉丝同台做游戏，还即兴回答了大家的提问。谈到一路以来的支持，她多次表达感谢：「是你们让我一直有动力。」",
      "活动尾声，杨幂与全场粉丝合影留念，并叮嘱大家注意身体、平安开心。现场不少粉丝表示「圆梦了」。",
    ],
  },
  {
    id: "yangmi-behind-scenes",
    title: "幕后花絮：杨幂剧组日常曝光 认真敬业获赞",
    category: "花絮",
    date: "2026-08-18",
    author: "剧组直击",
    summary: "一段剧组幕后花絮曝光，杨幂在片场认真背词、反复打磨动作戏的画面引发网友点赞。",
    cover: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20monitors%20lights%20and%20scripts%20on%20table%2C%20warm%20rose%20and%20amber%20practical%20lights%2C%20documentary%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-bts-05&orientation=landscape",
    content: [
      "近日，一段剧组幕后花絮在网络流传。画面中，杨幂在片场利用休息时间反复研读剧本，标注密密麻麻的批注，还会主动与导演、对手演员沟通走位。",
      "在一场动作戏的拍摄中，她多次亲自上阵完成镜头，即便劳累也坚持「再来一条」。工作人员透露，杨幂对细节要求很高，经常为了一个眼神和情绪反复调整。",
      "花絮曝光后，不少网友留言称赞她的敬业态度，「认真的人最有魅力」。",
    ],
  },
  {
    id: "yangmi-award-night",
    title: "杨幂出席年度盛典 斩获年度影响力演员",
    category: "活动",
    date: "2026-08-05",
    author: "娱乐速递",
    summary: "在年度影视盛典上，杨幂凭借多部作品的稳定表现，获颁年度影响力演员荣誉。",
    cover: "https://readdy.ai/api/search-image?query=Grand%20awards%20ceremony%20stage%20with%20golden%20light%20and%20spotlights%2C%20elegant%20trophy%20podium%2C%20luxurious%20warm%20rose%20and%20gold%20atmosphere%2C%20event%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-award-06&orientation=landscape",
    content: [
      "年度影视盛典近日举行，杨幂受邀出席并获颁年度影响力演员荣誉。她在台上感谢剧组与观众的支持，表示会继续用心打磨作品。",
      "过去一年，杨幂接连带来多部题材各异的作品，从都市到年代、从正剧到悬疑，展现了较强的可塑性。主办方在颁奖词中提到她「始终保持对表演的探索与热忱」。",
      "获奖后，杨幂在采访中表示，这份肯定会是继续前进的动力。",
    ],
  },
  {
    id: "yangmi-charity",
    title: "杨幂参与公益行动 关注儿童成长",
    category: "活动",
    date: "2026-07-22",
    author: "公益观察",
    summary: "杨幂低调参与一项关注儿童成长的公益活动，为孩子们送上书籍与祝福。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20community%20classroom%20with%20books%20and%20soft%20rose%20gold%20light%2C%20children%20reading%20area%2C%20hopeful%20gentle%20atmosphere%2C%20documentary%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-charity-07&orientation=landscape",
    content: [
      "近日，杨幂参与了一项关注儿童成长的公益行动，为孩子们送上了书籍与学习用品，并录制视频送上祝福。",
      "活动中，她与孩子们亲切交流，鼓励大家多读书、保持好奇心。杨幂表示，希望尽自己的一份力量，让更多孩子感受到温暖。",
      "据悉，这并非杨幂第一次参与公益。多年来，她持续关注儿童、环保等议题，用实际行动传递正能量。",
    ],
  },
  {
    id: "yangmi-box-office",
    title: "杨幂主演电影累计票房再创新高",
    category: "作品动态",
    date: "2026-07-10",
    author: "票房观察",
    summary: "随着新片上映，杨幂主演电影的累计票房再创新高，多部代表作持续保持着影响力。",
    cover: "https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20interior%20with%20glowing%20screen%20and%20warm%20rose%20gold%20ambient%20light%2C%20red%20seats%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-boxoffice-08&orientation=landscape",
    content: [
      "随着新片的上映，杨幂主演电影的累计票房再创新高。从青春片到科幻、从武侠到现实题材，她的电影作品覆盖了多种类型。",
      "数据显示，其主演作品在观众群体中保持着较高的关注度。业内分析认为，杨幂在商业片与文艺片之间的尝试，为其积累了不同类型的观众基础。",
      "对于票房成绩，杨幂此前曾表示，更看重观众对角色和故事的认可。",
    ],
  },
  {
    id: "yangmi-tv-rating",
    title: "杨幂主演剧集重播 收视表现依旧亮眼",
    category: "作品动态",
    date: "2026-06-28",
    author: "剧集观察",
    summary: "杨幂的经典剧集再度重播，收视与话题表现依旧亮眼，证明其作品的长期生命力。",
    cover: "https://readdy.ai/api/search-image?query=Retro%20television%20set%20with%20warm%20glow%20in%20cozy%20living%20room%20scene%2C%20rose%20and%20amber%20tones%2C%20nostalgic%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-rating-09&orientation=landscape",
    content: [
      "近日，杨幂的经典剧集再度登陆荧屏重播，收视表现依旧亮眼，社交平台上的讨论热度不减。",
      "不少观众表示，这些作品陪伴了自己的青春，「再看依然会被打动」。业内人士指出，经典剧集能够反复吸引观众，离不开角色塑造的扎实与情感表达的真诚。",
      "杨幂的多个经典角色也再次被网友热议，相关片段在短视频平台广泛传播。",
    ],
  },
  {
    id: "yangmi-director-praise",
    title: "合作导演盛赞杨幂：她对角色有难得的理解力",
    category: "访谈",
    date: "2026-06-15",
    author: "幕后访谈",
    summary: "一位与杨幂合作过的导演在采访中盛赞她的专业态度，称她对角色有难得的理解力。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20film%20director%20interview%20setting%20with%20clapperboard%20and%20soft%20rose%20gold%20light%2C%20minimal%20studio%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=ym-news-director-10&orientation=landscape",
    content: [
      "在近期的一次幕后访谈中，一位与杨幂合作过的导演对她的专业态度给予高度评价。",
      "该导演表示，杨幂在进组前会做大量功课，对人物的前史和动机有自己清晰的判断，「她对角色有难得的理解力，沟通起来很顺畅」。",
      "谈到印象最深的瞬间，导演回忆道，杨幂常常会主动提出不同的表演方案，「她愿意为角色多想一步，这在演员中很难得」。",
    ],
  },
];